import React, { useEffect, useState } from 'react';
import { X, Loader2 } from 'lucide-react';
interface CalendarModalProps {
  isOpen: boolean;
  onClose: () => void;
  calendarUrl?: string;
}
export function CalendarModal({
  isOpen,
  onClose,
  calendarUrl = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ15we5Z84BCJgL0PdPXeg7VE6V-NFCQe3XbznoFoVocWIujCjinQJ7FZgZ9Qt8K43-JbVRNg7ne?gv=true'
}: CalendarModalProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isVisible, setIsVisible] = useState(false);
  // Handle animation states
  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      // Reset loading state when opening
      setIsLoading(true);
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      // Restore body scroll
      document.body.style.overflow = 'unset';
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  if (!isVisible && !isOpen) return null;
  return <div className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-2162">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity" onClick={onClose} aria-hidden="true" data-id="element-2163" />

      {/* Modal Container */}
      <div className={`relative w-full max-w-[900px] h-[85vh] bg-[#1a1a1a] border border-white/10 rounded-2xl shadow-2xl flex flex-col overflow-hidden transition-all duration-300 transform ${isOpen ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'}`} data-id="element-2164">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 bg-[#1a1a1a]" data-id="element-2165">
          <h2 id="modal-title" className="text-lg font-semibold text-white" data-id="element-2166">
            Book A Strategy Call
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white/10 text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-[#3ab795]" aria-label="Close modal" data-id="element-2167">
            <X size={20} data-id="element-2168" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 relative bg-white w-full h-full" data-id="element-2169">
          {isLoading && <div className="absolute inset-0 flex items-center justify-center bg-[#1a1a1a] z-10" data-id="element-2170">
              <div className="flex flex-col items-center gap-3" data-id="element-2171">
                <Loader2 className="w-8 h-8 text-[#3ab795] animate-spin" data-id="element-2172" />
                <p className="text-gray-400 text-sm" data-id="element-2173">Loading calendar...</p>
              </div>
            </div>}
          <iframe src={calendarUrl} className="w-full h-full border-0" title="Schedule a call" onLoad={() => setIsLoading(false)} allow="camera; microphone; autoplay; fullscreen" data-id="element-2174" />
        </div>
      </div>
    </div>;
}